import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button, Box, CircularProgress, Alert, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface QRCodeDialogProps {
  open: boolean;
  onClose: () => void;
  isLoading: boolean;
  qrCodeImage: string | null;
  qrCodeError: string | null;
  onGenerateNewQRCode: () => void;
}

const QRCodeDialog: React.FC<QRCodeDialogProps> = ({ open, onClose, isLoading, qrCodeImage, qrCodeError, onGenerateNewQRCode }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6">Conectar WhatsApp</Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <Typography variant="body1" paragraph>
            Para conectar o WhatsApp:
          </Typography>
          <ol style={{ paddingLeft: 18 }}>
            <li>Abra o WhatsApp no seu celular</li>
            <li>Vá em Configurações → Aparelhos conectados</li>
            <li>Toque em "Conectar um aparelho"</li>
            <li>Escaneie o QR Code abaixo</li>
          </ol>
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
            {isLoading ? (
              <CircularProgress />
            ) : qrCodeError ? (
              <Alert severity="error" style={{ width: '100%' }}>{qrCodeError}</Alert>
            ) : qrCodeImage ? (
              <img src={qrCodeImage} alt="QR Code WhatsApp" style={{ maxWidth: 320 }} />
            ) : (
              <Typography color="text.secondary">Carregando QR Code...</Typography>
            )}
          </Box>
          <Alert severity="info">
            <Typography variant="body2">
              <strong>Importante:</strong> O QR Code expira em alguns minutos. Se não conseguir escanear, clique em "Gerar Novo QR Code".
            </Typography>
          </Alert>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button onClick={onGenerateNewQRCode} variant="outlined">Gerar Novo QR Code</Button>
      </DialogActions>
    </Dialog>
  );
};

export default QRCodeDialog;


